import React from 'react'
import { graphql } from 'gatsby'
import { usePreview, makeSlices } from '@kogk/gatsby-theme-prismic'
import '@src/data/prismic-fragments/page'
import MainLayout from '@cmp/layout/MainLayout/MainLayout'
import sliceMapping from '@src/data/prismic-slice-mapping/page-slices'
import { GlobalDataProvider } from '@src/data/global-data'

const Slices = makeSlices(sliceMapping)

interface Props {
  data: any
}

const Page = ({ data: staticData }: Props) => {
  const data = usePreview(staticData)

  return (
    <GlobalDataProvider language='en' altUrls={[]}>
      <MainLayout>
        <article className='page-wrap'>
          <Slices body={data.prismicPage.data.body} />
        </article>
      </MainLayout>
    </GlobalDataProvider>
  )
}

export default Page

export const query = graphql`
  query genericPageQuery($prismicId: ID!) {
    prismicPage(prismicId: { eq: $prismicId }) {
      ...prismicPageFragmentFull
    }
  }
`
